import { ErrorHandler, Injectable } from '@angular/core';
import { InsightsService } from 'shared-states';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

  constructor(private _insightsService: InsightsService) {}

  handleError(error: any): void {
    // Extract the actual error from Angular's wrapper (e.g., promise rejections)
    const actualError = error?.rejection ?? error;

    // Build custom properties
    const properties: Record<string, string> = {};

    // Detect remote module load failures
    const remoteModuleName = this.extractRemoteModuleName(actualError);
    if (remoteModuleName) {
      properties['remoteModule'] = remoteModuleName;
      properties['errorType'] = 'RemoteModuleLoadFailure';
    }

    // Forward to Application Insights via InsightsService
    this._insightsService.trackException(
      actualError instanceof Error ? actualError : new Error(String(actualError)),
      properties
    );

    // Preserve default Angular error logging behavior
    console.error(error);
  }

  private extractRemoteModuleName(error: any): string | null {
    const message = error?.message ?? String(error);

    // Match patterns like "Loading remote module <name> failed"
    // or chunk load errors referencing remoteEntry.js
    const remoteMatch = message.match(/remote(?:Entry|Module|Name)[:\s]*['"]?(\w+)/i);
    if (remoteMatch) {
      return remoteMatch[1];
    }

    // Match webpack chunk load errors for known remotes
    const chunkMatch = message.match(/Loading chunk .*?(\w+).*?failed/i);
    if (chunkMatch) {
      return chunkMatch[1];
    }

    return null;
  }
}
